
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Music, Disc, PlayCircle, BarChart2 } from 'lucide-react';

const ReleasesSection: React.FC = () => {
  // Mock releases data
  const releases = [
    { id: 1, title: "Midnight Dreams", type: "Single", releaseDate: "Apr 15, 2024", streams: 24520, saves: 1842 },
    { id: 2, title: "Echoes of Tomorrow", type: "EP", releaseDate: "Mar 1, 2024", streams: 58942, saves: 4218 },
    { id: 3, title: "Urban Pulse", type: "Single", releaseDate: "Jan 12, 2024", streams: 32184, saves: 2635 },
    { id: 4, title: "Reflections", type: "Album", releaseDate: "Oct 5, 2023", streams: 104782, saves: 8942 }
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <Card className="bg-card/95 border-border/50 lg:col-span-2">
        <CardHeader>
          <CardTitle className="text-xl flex items-center gap-2 text-white/95">
            <Disc className="h-5 w-5 text-soundcharts-purple" />
            Recent Releases
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-white/10">
                  <th className="text-left py-3 px-4 text-sm font-medium text-white/70">Title</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-white/70">Type</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-white/70">Release Date</th>
                  <th className="text-right py-3 px-4 text-sm font-medium text-white/70">Streams</th>
                  <th className="text-right py-3 px-4 text-sm font-medium text-white/70">Saves</th>
                </tr>
              </thead>
              <tbody>
                {releases.map((release) => (
                  <tr key={release.id} className="border-b border-white/10 hover:bg-white/5 transition-colors">
                    <td className="py-3 px-4 flex items-center gap-2 text-white/95">
                      <Music className="h-4 w-4 text-soundcharts-purple" />
                      <span>{release.title}</span>
                    </td>
                    <td className="py-3 px-4 text-white/95">{release.type}</td>
                    <td className="py-3 px-4 text-white/95">{release.releaseDate}</td>
                    <td className="py-3 px-4 text-right text-white/95">{release.streams.toLocaleString()}</td>
                    <td className="py-3 px-4 text-right text-white/95">{release.saves.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-card/95 border-border/50">
        <CardHeader>
          <CardTitle className="text-xl flex items-center gap-2 text-white/95">
            <BarChart2 className="h-5 w-5 text-soundcharts-purple" />
            Release Performance
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-white/95">Total Releases</span>
                <span className="text-sm font-medium text-white/95">12</span>
              </div>
              <div className="grid grid-cols-4 gap-1 text-xs text-center">
                <div>
                  <div className="bg-soundcharts-purple/20 p-2 rounded-md">
                    <div className="text-lg font-semibold text-white/95">8</div>
                    <div className="text-white/70">Singles</div>
                  </div>
                </div>
                <div>
                  <div className="bg-soundcharts-purple/20 p-2 rounded-md">
                    <div className="text-lg font-semibold text-white/95">2</div>
                    <div className="text-white/70">EPs</div>
                  </div>
                </div>
                <div>
                  <div className="bg-soundcharts-purple/20 p-2 rounded-md">
                    <div className="text-lg font-semibold text-white/95">2</div>
                    <div className="text-white/70">Albums</div>
                  </div>
                </div>
                <div>
                  <div className="bg-soundcharts-purple/20 p-2 rounded-md">
                    <div className="text-lg font-semibold text-white/95">0</div>
                    <div className="text-white/70">Remixes</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <div className="text-sm font-medium mb-2 text-white/95">Top Performing Release</div>
              <div className="border border-soundcharts-purple/30 bg-black/20 rounded-md p-4">
                <div className="flex items-center gap-2 mb-2">
                  <PlayCircle className="h-8 w-8 text-soundcharts-purple" />
                  <div>
                    <div className="font-semibold text-white/95">Reflections</div>
                    <div className="text-xs text-white/70">Album • Oct 5, 2023</div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2 mt-3">
                  <div className="bg-soundcharts-purple/10 p-2 rounded-md text-center">
                    <div className="text-xs text-white/70">Streams</div>
                    <div className="font-semibold text-white/95">104,782</div>
                  </div>
                  <div className="bg-soundcharts-purple/10 p-2 rounded-md text-center">
                    <div className="text-xs text-white/70">Saves</div>
                    <div className="font-semibold text-white/95">8,942</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ReleasesSection;
